import { DocumentEntry } from '../interfaces';
import { Document, Property, RFXIdentifier, RFXRevisionedId } from './RFXBackendModel';

export interface RFXQuestion {
  rfxQuestionRevisionedId: RFXRevisionedId;
  rfxQuestionVersion: number;
  rfxRequestRevisionedId: RFXRevisionedId;
  author: RFXQuestionUser;
  rfxQuestionClassId: RFXIdentifier;
  title?: string;
  message: string;
  contentType: string;
  answers?: RFXAnswer[];
  comments?: RFXComment[];
  createdAt: number;
  lastUpdatedAt?: number;
  properties?: Property[];
  rfxQuestionDocuments: Document[];
}

export interface RFXAnswer {
  rfxAnswerRevisionedId: RFXRevisionedId;
  rfxAnswerVersion: number;
  author: RFXQuestionUser;
  message: string;
  contentType: string;
  comments?: RFXComment[];
  createdAt: number;
  lastUpdatedAt?: number;
}

export interface RFXComment {
  rfxCommentRevisionedId: RFXRevisionedId;
  rfxCommentVersion: number;
  author: RFXQuestionUser;
  message: string;
  contentType: string;
  createdAt: number;
  lastUpdatedAt?: number;
}

export interface RFXQuestionUser {
  userType: RFXUserType;
  id: RFXIdentifier;
}

export enum RFXUserType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL'
}

export interface PutRFXQuestionInput {
  rfxQuestion: RFXQuestion;
}

export interface PutRFXQuestionOutput {
  rfxQuestionId: RFXRevisionedId;
  rfxQuestionVersion: number;
}

export interface LoadRFXQuestionInput {
  id: RFXRevisionedId;
}

export interface LoadRFXQuestionOutput {
  rfxQuestion?: RFXQuestion;
}

export interface PutRFXAnswerInput {
  rfxQuestionId: RFXRevisionedId;
  rfxAnswer: RFXAnswer;
}

export interface PutRFXAnswerOutput {
  rfxQuestionId: RFXRevisionedId;
  rfxQuestionVersion: number;
  rfxAnswerRevisionedId: RFXRevisionedId;
  rfxAnswerVersion: number;
}

export interface GetRFXQuestionsForRequestInput {
  rfxRequestRevisionedId: RFXRevisionedId;
  nextToken?: string;
  maxResults?: number;
}

export interface GetRFXQuestionsForRequestOutput {
  rfxQuestions?: RFXQuestion[];
  nextToken?: string;
}

export interface RFXQuestionDocumentEntry extends DocumentEntry {
  rfxQuestionRevisionedId: RFXRevisionedId;
  rfxRequestRevisionedId: RFXRevisionedId;
  size: string;
  author: RFXQuestionUser;
}

export interface InsertRFXQuestionDocumentEntryInput {
  userId: string;
  documentEntry: RFXQuestionDocumentEntry;
}
